import type { ProductPrice } from '@/graphql/types/graphql'

export function usePrice(price: ProductPrice | undefined | null) {
    const regularPrice = price?.regularPrice
    const finalPrice = price?.finalPrice
    const currencyCode = finalPrice?.currency?.name
    const priceSymbol = finalPrice?.currency?.symbol
    const currencyItem = finalPrice?.currency

    const inPromotion = computed(() => {
        return regularPrice?.value !== finalPrice?.value
    })

    const priceDiscount = inPromotion.value ? finalPrice?.value : ''

    const currentPrice = inPromotion.value ? finalPrice?.value : regularPrice?.value

    return {
        finalPrice: finalPrice?.value,
        regularPrice: regularPrice?.value,
        currencyCode,
        inPromotion: inPromotion.value,
        currentPrice,
        priceSymbol,
        priceDiscount,
        currencyItem,
    }
}
